import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { listEnterprises, downloadEnterpriseReport, readableApiError } from '../../api/dashboard';
import './dashboard.css';

/**
 * 超管 / admin 企业选择器（spec §4.4，纯镜像 AIQ）。
 * 按 classes_enabled 分流：班级制→班级列表（带 enterprise 过滤）；裸码→全员看板。
 */
export default function EnterpriseListPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  const [dlError, setDlError] = useState(null);
  const navigate = useNavigate();

  const onDownload = async (ent) => {
    setDownloadingId(ent.id); setDlError(null);
    const res = await downloadEnterpriseReport(ent.id);
    setDownloadingId(null);
    if (!res.ok) setDlError(`${ent.name}：${res.error || '下载失败'}`);
  };

  useEffect(() => {
    listEnterprises()
      .then(setData)
      .catch((err) => setError(readableApiError(err, '加载企业列表失败')));
  }, []);

  const openEnterprise = (ent) => {
    if (ent.classes_enabled) {
      navigate(`/dashboard/classes?enterprise=${ent.id}`, { state: { enterpriseName: ent.name } });
    } else {
      navigate(`/dashboard/enterprises/${ent.id}`);
    }
  };

  return (
    <div className="aiq-dash dash-page">
      <Link to="/" className="dash-back">← 返回首页</Link>
      <div className="dash-head">
        <h1 className="dash-h1">企业看板</h1>
        <p className="dash-sub">选择企业查看其团队 / 全员测评看板。</p>
      </div>
      {error && <div className="dash-card dash-card--error">{error}</div>}
      {!data && !error && <div className="dash-card">加载中...</div>}
      {data && data.results.length === 0 && (
        <div className="dash-card"><div className="dash-mut">暂无企业</div></div>
      )}
      {dlError && <div className="dash-card dash-card--error">{dlError}</div>}
      {data && data.results.map((ent) => (
        <div key={ent.id} className="dash-card"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <div role="button" tabIndex={0} onClick={() => openEnterprise(ent)}
            onKeyDown={(e) => { if (e.key === 'Enter') openEnterprise(ent); }}
            style={{ flex: 1, cursor: 'pointer' }}>
            <div style={{ fontWeight: 600 }}>{ent.name}</div>
            <div className="dash-mut">
              {ent.industry || '未指定行业'} · {ent.member_count ?? 0} 人 · 已完成 {ent.completed_count ?? 0}
            </div>
          </div>
          <button type="button" onClick={() => onDownload(ent)} disabled={downloadingId === ent.id}
            style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 8,
              padding: '8px 14px', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
              cursor: downloadingId === ent.id ? 'default' : 'pointer', opacity: downloadingId === ent.id ? 0.6 : 1 }}>
            {downloadingId === ent.id ? '生成中…' : '下载报告'}
          </button>
        </div>
      ))}
    </div>
  );
}
